import { render, staticRenderFns } from "./SummaryCards.vue?vue&type=template&id=4f527fe0&scoped=true"
import script from "./SummaryCards.vue?vue&type=script&lang=js"
export * from "./SummaryCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f527fe0",
  null
  
)

export default component.exports